import { render, staticRenderFns } from "./ChoiceFields.vue?vue&type=template&id=c29a9c32&scoped=true&"
import script from "./ChoiceFields.vue?vue&type=script&lang=js&"
export * from "./ChoiceFields.vue?vue&type=script&lang=js&"
import style0 from "./ChoiceFields.vue?vue&type=style&index=0&id=c29a9c32&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c29a9c32",
  null
  
)

export default component.exports